import { useState } from "react"
import { crmSlides } from "../../data/data"
import circle from "../../images/circle.svg"

export default function CRMSlides() {
  const [slides] = useState(crmSlides)
  const [value, setValue] = useState(0)

  const { title, image, desc } = slides[value]

  return (
    <>
      <section className="px-5 2xl:px-0 xl:max-w-6xl xl:mx-auto py-10 lg:py-20">
        <h2 className="text-3xl text-center lg:text-5xl mb-5 lg:mb-10">
          {title}
        </h2>

        <div className="md:grid grid-cols-2 gap-10 items-center">
          <article>
            <img
              src={image}
              alt={title}
              title={title}
              className="block mx-auto"
            />

            <div className="md:hidden flex flex-wrap items-center justify-center mt-10">
              {slides.map((slide, index) => (
                <button
                  onClick={() => setValue(index)}
                  className={`btn-slide m-1 ${
                    index === value && "btn-slide-active"
                  }`}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          </article>

          <article>
            <ul className="grid grid-cols-1 pl-10 mt-5">
              {desc.map((d, index) => (
                <li
                  key={index}
                  className="flex items-center font-bold text-sm lg:text-2xl my-2 lg:my-4 text-gray-800"
                >
                  <img
                    src={circle}
                    alt="Circle"
                    title="Circle"
                    className="mr-2"
                  />{" "}
                  {d}
                </li>
              ))}
            </ul>
          </article>
        </div>

        <div className="hidden md:block">
          <div className="flex flex-wrap items-center justify-center mt-10">
            {slides.map((slide, index) => (
              <button
                onClick={() => setValue(index)}
                className={`btn-slide m-1 md:mx-3 ${
                  index === value && "btn-slide-active"
                }`}
              >
                {index + 1}
              </button>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
